import { useXcoreUtils } from "@robe/client";
import { FileValue } from "@robe/core";
import { Box, Typography, Collapse, Grid, Link } from "@xcorejs/ui";
import GoboCard from "design-system/robe/Cards/Gobo";
import RobeGobosHeading from "design-system/robe/RobeGobosHeading";
import { useState, useEffect, Fragment } from "react";
import { WheelValues, GoboValues } from "xcore/types";
import { useGallery } from "../data";

interface WheelSetProps {
  wheelSetValues: WheelValues;
  wheelsValues: GoboValues[];
  setActive: (i: number) => void;
  active?: number;
}

export const WheelSet = ({ wheelSetValues, wheelsValues, setActive, active, ...props }: WheelSetProps) => {
  const [showWheels, setShowWheels] = useState(true);
  const { image: imageFunc, stringify } = useXcoreUtils();
  const [openLightbox] = useGallery({
    images: wheelsValues
      .filter(({ image }) => !!image)
      .map(({ image }) => imageFunc(image as FileValue<{ width: 300; height: 300 }>, { width: 300, height: 300 })),
    white: true,
  });

  useEffect(() => setShowWheels(window.innerWidth >= 768), []);

  return (
    <Box {...props}>
      {wheelSetValues && (
        <Typography variant="h3" display={{ _: "none", sm: "block" }}>
          {stringify(wheelSetValues.name)}
        </Typography>
      )}

      <RobeGobosHeading display={{ _: "flex", sm: "none" }} active={showWheels} onClick={() => setShowWheels(!showWheels)}>
        {stringify(wheelSetValues?.name)}
      </RobeGobosHeading>

      <Collapse open={showWheels}>
        <Box
          position="relative"
          maxWidth={{ _: "100vw", sm: "5000px" }}
          overflowX={{ _: "auto", sm: "visible" }}
          marginLeft="-1.5rem"
          paddingX="1.5rem"
          mt="2rem"
        >
          <Grid
            columns={
              wheelSetValues?.large
                ? { _: "repeat(50, 1fr)", sm: "repeat(2, 1fr)", xl: "repeat(3, 1fr)" }
                : { _: "repeat(50, 1fr)", sm: "repeat(4, 1fr)", xl: "repeat(6, 1fr)" }
            }
            rows="auto"
            gap="1rem"
          >
            {wheelsValues.map((values, i) => (
              <Fragment key={i}>
                <Link type="simple" onClick={() => setActive(i)} display={{ _: "none", sm: "inline-flex" }} width="100%">
                  <GoboCard goboValues={values} active={active === i} large={wheelSetValues?.large} />
                </Link>
                <Link type="simple" display={{ _: "inline-flex", sm: "none" }} onClick={() => openLightbox(i)} width="100%">
                  <GoboCard goboValues={values} active={active === i} large={wheelSetValues?.large} />
                </Link>
              </Fragment>
            ))}
          </Grid>
        </Box>
      </Collapse>
    </Box>
  );
};
